import { QuoteItem } from './quote';

export interface AttributeBase {
    code?: string;
    value?: string;
    label?: string;
}

export interface ConfigurationsBase {
    colors: AttributeBase[];
    capacitys: AttributeBase[];
}

export interface ConfigurationBase {
    color: string;
    capacity: string;
}

export interface ProductSerializedBase {
    gencode: string;
    uniqueId: string;
    price: number;
    quoteItem: QuoteItem;
}

export enum ConfiguratorType {
    PORTA = 'porta',
    EDP = 'EDP',
    CONVERGENCE = 'convergence',
    LOCALES = 'locales',
    CUSTOMER = 'customer',
}
